module.exports = require('./flashls')



// WEBPACK FOOTER //
// ./src/playbacks/flashls/index.js